import React, { useState } from 'react';
import { useCart } from './CartContext';
import { createOrder } from "../../api/api";
import { WHATSAPP_NUMBER } from "../../constants/constants";
import '../cart/cart.scss';
import {Modal, ModalField} from "../../components/User_Side/modal/Modal";
import ReactDOM from "react-dom";
import {useTranslation} from "react-i18next";

const Cart = () => {
    const {t} = useTranslation()
    const { cart, clearCart, removeFromCart, updateQty, totalItems } = useCart();
    const [open, setOpen] = useState(false);
    const [modal, setModal] = useState<{
        message: string;
        onConfirm: (data?: Record<string, string>) => void;
        onCancel?: () => void;
        submitted: boolean;
        confirmationText: string;
        confirmLabel?: string;
        cancelLabel?: string;
        fields?: ModalField[];
    } | null>(null);
    const totalPrice = cart.reduce((sum, item) => {
        const price = parseFloat(item.price.replace(/[^0-9.]/g, ''));
        return sum + price * item.qty;
    }, 0);

    const handleWhatsAppOrder = async () => {
        if (cart.length === 0) return;

        setModal({
            message: `${t('cart.order-infos')}`,
            fields: [
                { name: 'customerName', label: `${t('cart.your-name')}`, placeholder: `${t('cart.name')}` },
                { name: 'customerPhone', label: `${t('cart.your-phone')}`, type: 'tel', placeholder: '+33 6 00 00 00' },
            ],
            submitted: false,
            confirmationText: `${t('cart.validated')}`,
            confirmLabel: `${t('cart.whatsapp-order')}`,
            cancelLabel: `${t('cart.cancel')}`,
            onCancel: () => setModal(null),
            onConfirm: async (data) => {
                const customerName = data?.customerName || `${t('cart.customer')}`;
                const customerPhone = data?.customerPhone || '';

                try {
                    await createOrder({
                        customerName,
                        customerPhone,
                        total: totalPrice,
                        items: cart.map(item => (
                            {
                                productId: item.id,
                                qty: item.qty,
                                price: item.price
                            }))
                    });
                } catch (e) {
                    console.error(e);
                }

                const lines = cart.map(item => `• ${item.name} x${item.qty} — ${item.price}`);
                const message = `Bonjour Mariposa,\nCommande de ${customerName} :\n${lines.join('\n')}\nTotal : ${totalPrice.toFixed(2)} €`;
                const waUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

                setTimeout(() => {
                    setModal({
                        message: `${t("cart.registered-order")}`,
                        confirmLabel: `${t("cart.open-whatsapp")}`,
                        cancelLabel: `${t("cart.later")}`,
                        submitted:false,
                        confirmationText: `${t('cart.validated')}`,
                        onCancel: () => { setModal(null); clearCart(); },
                        onConfirm: () => {
                            window.open(waUrl, '_blank');
                            clearCart();
                            setModal(null);
                        }
                    });
                }, 100);
            }
        });
    };

    return (
        <>{modal && ReactDOM.createPortal(<Modal {...modal} />, document.body)}
            <button className="cart-fab" onClick={() => setOpen(o => !o)} aria-label="Panier">
                🛍️
                {totalItems > 0 && <span className="cart-badge">{totalItems}</span>}
            </button>

            {open && (
                <div className="cart-drawer">
                    <div className="cart-header">
                        <h3>{t("cart.my-basket")}</h3>
                        <button className="cart-close" onClick={() => setOpen(false)}>✕</button>
                    </div>

                    {cart.length === 0 ? (
                        <p className="cart-empty">{t("cart.empty-basket")}</p>
                    ) : (
                        <>
                            <ul className="cart-list">
                                {cart.map(item => (
                                    <li key={item.id} className="cart-item">
                                        <img src={item.imageUrl} alt={item.name} />
                                        <div className="cart-item-info">
                                            <p className="cart-item-name">{item.name}</p>
                                            <p className="cart-item-price">{item.price}</p>
                                            <div className="cart-item-qty">
                                                <button onClick={() => updateQty(item.id, item.qty - 1)}>−</button>
                                                <span>{item.qty}</span>
                                                <button onClick={() => updateQty(item.id, item.qty + 1)}>+</button>
                                            </div>
                                        </div>
                                        <button className="cart-item-remove" onClick={() => removeFromCart(item.id)}>✕</button>
                                    </li>
                                ))}
                            </ul>

                            <div className="cart-footer">
                                <p className="cart-total">{t("cart.total")} : <strong>{totalPrice.toFixed(2)} €</strong></p>
                                <button className="cart-whatsapp" onClick={() => {
                                    handleWhatsAppOrder();
                                }}>
                                    {t("cart.whatsapp-order")} 💬
                                </button>
                                <button className="cart-clear" onClick={clearCart}>
                                    {t("cart.empty-your-basket")}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            )}

            {open && <div className="cart-overlay" onClick={() => setOpen(false)} />}
        </>
    );
};

export default Cart;
